import { getBrowserRouterBasePath } from '../config/publicAssetPath';
import { runtimeConfig } from '../config/runtimeConfig';
import { deleteCookie, getCookie, setAccessToken, setRefreshToken } from '../cookie';
import mem from 'mem';
import Swal from 'sweetalert2';
import axios from 'axios';

const client = axios.create({
  // axios 버전이 바뀌면서 기존 문법이 안먹히던 이슈 발생
  // headers의 Content-Type와 Accpet 설정 & config.headers 설정
  // baseURL: "http://localhost:8080/api",
  // baseURL: "http://13.125.160.114/api",
  // baseURL: "https://cloud-ih.shop/api",
  // baseURL: "https://admin.edgecross.ai/api",
  // baseURL: "https://71a7-112-171-127-186.ngrok-free.app/api",
  baseURL: runtimeConfig.backendAddress,

  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    'ngrok-skip-browser-warning': runtimeConfig.ngrokSkipBrowserWarning,
    Accept: 'application/json,',
  },
});

const BROWSER_ROUTER_BASE_PATH = getBrowserRouterBasePath();
const LOGIN_PATH = BROWSER_ROUTER_BASE_PATH || '/';

client.interceptors.request.use((config: any) => {
  const accessToken = getCookie('Authorization');
  config.headers.Authorization = `Bearer ${accessToken}`;
  return config;
});

const getReissueToken = mem(
  async (): Promise<string | void> => {
    const AccessToken = getCookie('Authorization');
    const RefreshToken = getCookie('RefreshToken');
  
    try {
      const reissue = await axios({
        url: `${runtimeConfig.backendAddress}/reissue`,
        method: 'get',
        headers: {
          Authorization: `Bearer ${AccessToken}`,
          RAuthorization: `Bearer ${RefreshToken}`,
        },
      });
      if (reissue) {
        setAccessToken(reissue.data.accessToken);
        setRefreshToken(reissue.data.refreshToken);
      }
      return reissue.data;
    } catch (error) {
      deleteCookie('Authorization');
      deleteCookie('RefreshToken');

      Swal.fire({
        title: '세션이 만료되었습니다.',
        text: '다시 로그인 해주세요.',
        icon: 'error',
        confirmButtonText: '확인',
      });

      window.location.href = LOGIN_PATH;
    }
  },
  { maxAge: 1000 },
);

client.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    const {
      config,
      response: { data, status },
    } = err;

    if (config.url === `/auth/token` || status !== 401 || config.sent) {
      return Promise.reject(err);
    }

    config.sent = true;

    const isFormData = config.data instanceof FormData;
    switch (data.message) {
      case 'err_token_expired': {
        config.sent = true;

        const accessToken = await getReissueToken();
        if (!accessToken) break;

        config.headers = {
          ...config.headers,
          Authorization: `Bearer ${accessToken}`,
          accept: 'application/json, text/plain, */*',
          'content-type': isFormData ? 'multipart/form-data' : 'application/json',
        };

        return client.request(config);
      }

      case 'err_authentication_failed':
      case 'err_invalid_token':
      case 'err_invalid_access_token': {
        deleteCookie('Authorization');
        deleteCookie('RefreshToken');
        sessionStorage.removeItem('tenant');
        // 로그인 화면으로 이동
        Swal.fire({
          title: '세션이 만료되었습니다.',
          text: '다시 로그인 해주세요.',
          icon: 'error',
          confirmButtonText: '확인',
        });
        window.location.href = LOGIN_PATH;
        break;
      }

      default:
        break;
    }

    return Promise.reject(err);
  },
);

export default client;
